const filterByDate = (dateStart, dateEnd, originImages) => {
	if (!dateStart && !dateEnd) return originImages;

	let dateStartsMili = new Date(dateStart).getTime();
	let dateEndsMili = new Date(dateEnd).getTime();
	let resultFilterByDate = originImages.filter((item) => {
		let created_at = new Date(item.created_at).getTime();
		return created_at >= dateStartsMili && created_at <= dateEndsMili;
	});

	return resultFilterByDate;
};

export { filterByDate };
